export const appConfig = Object.freeze({
  supabaseUrl: String(import.meta.env.VITE_SUPABASE_URL || "").trim(),
  supabaseKey: String(import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || "").trim(),
  environment: String(import.meta.env.VITE_APP_ENV || "local").trim(),
  publicSiteUrl: String(import.meta.env.VITE_PUBLIC_SITE_URL || window.location.origin).replace(/\/+$/, "")
});

export const hasSupabaseConfig = Boolean(
  appConfig.supabaseUrl &&
  appConfig.supabaseKey &&
  !appConfig.supabaseUrl.includes("YOUR_PROJECT_REF") &&
  !appConfig.supabaseKey.includes("YOUR_PUBLISHABLE")
);
